import { jsx as _jsx } from "react/jsx-runtime";
import { Textarea } from '@skbkontur/react-ui';
import { ValidationWrapper } from '@skbkontur/react-ui-validations';
import { FieldWrapper } from '../../../FieldWrapper';
export const DocumentIssuerField = ({ value, onValueChange, validationInfo, disabled, labelClassName, width, }) => {
    return (_jsx(FieldWrapper, { label: "\u041A\u0435\u043C \u0432\u044B\u0434\u0430\u043D", labelClassName: labelClassName, children: _jsx(ValidationWrapper, { validationInfo: validationInfo, children: _jsx(Textarea, { "data-tid": "issuerInput", onValueChange: onValueChange, value: value, disabled: disabled, width: width || 348 }) }) }));
};
